function Privacy() {
  return (
        <div className="mx-4 mb-16 sm:mx-16">
          <h1 className="py-4 font-bold text-[30px] md:text-[32px] lg:text-[36px] text-center text-transparent bg-clip-text bg-gradient-to-l from-adhocDonkerBlauw to-adhocBlauw">
            Privacy statement
          </h1>
          <div className="mx-auto md:w-8/12">
            <p className="mt-4">
              Ad Hoc IT Services is verantwoordelijk voor de verwerking van
              persoonsgegevens zoals weergegeven in deze privacyverklaring.
            </p>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Contactgegevens:{" "}
              </h1>
              <p>
                https://www.adhocit.nl
                <br />
                +31 6 20503666
              </p>
            </div>
            <p className="mt-4">
              Ali Jirrie is de Functionaris Gegevensbescherming van Ad Hoc IT
              Services. Hij is te bereiken via{" "}
              <a className="underline" href="mailto:ali@adhocit.nl">
                ali@adhocit.nl
              </a>
            </p>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Persoonsgegevens die wij verwerken
              </h1>
              <p>
                Ad Hoc IT Services verwerkt uw persoonsgegevens doordat u
                gebruik maakt van onze diensten en/of omdat u deze zelf aan ons
                verstrekt. Hieronder vindt u een overzicht van de
                persoonsgegevens die wij verwerken:
              </p>
              <p>- Voor- en achternaam</p>
              <p>- Telefoonnummer</p>
              <p>- E-mailadres</p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Bijzondere en/of gevoelige persoonsgegevens die wij verwerken
              </h1>
              <p>
                Onze website en/of dienst heeft niet de intentie gegevens te
                verzamelen over websitebezoekers die jonger zijn dan 16 jaar.
                Tenzij ze toestemming hebben van ouders of voogd. We kunnen
                echter niet controleren of een bezoeker ouder dan 16 is. Wij
                raden ouders dan ook aan betrokken te zijn bij de online
                activiteiten van hun kinderen, om zo te voorkomen dat er
                gegevens over kinderen verzameld worden zonder ouderlijke
                toestemming. Als u er van overtuigd bent dat wij zonder die
                toestemming persoonlijke gegevens hebben verzameld over een
                minderjarige, neem dan contact met ons op via
                service@adhocit.nl, dan verwijderen wij deze informatie.
              </p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Met welk doel en op basis van welke grondslag wij
                persoonsgegevens{" "}
              </h1>
              <p>
                verwerken Ad Hoc IT Services verwerkt uw persoonsgegevens voor
                de volgende doelen:
              </p>
              <p>
                - U te kunnen bellen of e-mailen indien dit nodig is om onze
                dienstverlening uit te kunnen voeren
              </p>
              <p>
                - U te informeren over wijzigingen van onze diensten en
                producten
              </p>
              <p>- Om goederen en diensten bij u af te leveren</p>
            </div>
            <div className="mt-4">
              <h1>Hoe lang we persoonsgegevens bewaren</h1>
              <p>
                Ad Hoc IT Services bewaart uw persoonsgegevens niet langer dan
                strikt nodig is om de doelen te realiseren waarvoor uw gegevens
                worden verzameld. Wij hanteren een bewaartermijn van
                persoonsgegevens van 4 weken.
              </p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Delen van persoonsgegevens met derden
              </h1>
              <p>
                Ad Hoc IT Services verstrekt uitsluitend aan derden en alleen
                als dit nodig is voor de uitvoering van onze overeenkomst met u
                of om te voldoen aan een wettelijke verplichting.
              </p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Cookies, of vergelijkbare technieken, die wij gebruiken
              </h1>
              <p>
                Ad Hoc IT Services gebruikt alleen technische en functionele
                cookies. En analytische cookies die geen inbreuk maken op uw
                privacy. Een cookie is een klein tekstbestand dat bij het eerste
                bezoek aan deze website wordt opgeslagen op uw computer, tablet
                of smartphone. De cookies die wij gebruiken zijn noodzakelijk
                voor de technische werking van de website en uw gebruiksgemak.
                Ze zorgen ervoor dat de website naar behoren werkt en onthouden
                bijvoorbeeld uw voorkeursinstellingen. Ook kunnen wij hiermee
                onze website optimaliseren. U kunt zich afmelden voor cookies
                door uw internetbrowser zo in te stellen dat deze geen cookies
                meer opslaat. Daarnaast kunt u ook alle informatie die eerder is
                opgeslagen via de instellingen van uw browser verwijderen.
              </p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Gegevens inzien, aanpassen of verwijderen
              </h1>
              <p>
                U heeft het recht om uw persoonsgegevens in te zien, te
                corrigeren of te verwijderen. Daarnaast heeft u het recht om uw
                eventuele toestemming voor de gegevensverwerking in te trekken
                of bezwaar te maken tegen de verwerking van uw persoonsgegevens
                door Ad Hoc IT Services en heeft u het recht op
                gegevensoverdraagbaarheid. Dat betekent dat u bij ons een
                verzoek kunt indienen om de persoonsgegevens die wij van u
                beschikken in een computerbestand naar u of een ander, door u
                genoemde organisatie, te sturen. U kunt een verzoek tot inzage,
                correctie, verwijdering, gegevensoverdraging van uw
                persoonsgegevens of verzoek tot intrekking van uw toestemming of
                bezwaar op de verwerking van uw persoonsgegevens sturen naar
                service@adhocit.nl. Om er zeker van te zijn dat het verzoek tot
                inzage door u is gedaan, vragen wij u een kopie van uw
                identiteitsbewijs met het verzoek mee te sturen. Maak in deze
                kopie uw pasfoto, MRZ (machine readable zone, de strook met
                nummers onderaan het paspoort), paspoortnummer en
                Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw
                privacy. We reageren zo snel mogelijk, maar binnen vier weken,
                op uw verzoek. Ad Hoc IT Services wil u er tevens op wijzen dat
                u de mogelijkheid heeft om een klacht in te dienen bij de
                nationale toezichthouder, de Autoriteit Persoonsgegevens.
              </p>
            </div>
            <div className="mt-4">
              <h1 className="font-semibold text-[18px] lg:text-[20px]">
                Hoe wij persoonsgegevens beveiligen{" "}
              </h1>
              <p>
                Ad Hoc IT Services neemt de bescherming van uw gegevens serieus
                en neemt passende maatregelen om misbruik, verlies, onbevoegde
                toegang, ongewenste openbaarmaking en ongeoorloofde wijziging
                tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed
                beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan
                contact op met onze klantenservice of via service@adhocit.nl
              </p>
            </div>
          </div>
        </div>
  );
}

export default Privacy;
